import httpClient from '@/core/http/client.service';

const addDrugForPatient = (data) => httpClient.post('/api/v1/order/drug/add?_format=json', data);

const removeDrugForPatient = (data) => httpClient.post('/api/v1/order/drug/remove?_format=json', data);

const updateDrug = (data) => httpClient.post('/api/v1/order/drug/edit?_format=json', data);

const publicHolidays = (data) => httpClient.get(`/api/v1/public-holidays?_format=json&state=${data.state}`);

export default {
  addDrugForPatient,
  removeDrugForPatient,
  updateDrug,
  publicHolidays,
};
